/*
 * @Author: Tang Hao
 * @Date: 2024-07-05 15:05:48
 * @LastEditors: Tang Hao
 * @LastEditTime: 2025-12-22 10:48:47
 * @Description:
 */
import Form, { formCreate } from '@/found/components/form';
import FundDetails from './fundDetails.vue';

formCreate.component('FundDetails', FundDetails);
export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      progressList: [],
      chooseAct: [],
      formFunctionCode: 'fund_details',
      formParentCode: 'CRM20230601000000004',
      buttons: {
        submit: false,
      },
    };
  },

  created() {},

  methods: {
    // 设置rule
    setRule(item) {
      const v = item;
      if (v.field === 'fundDetails') {
        const { row, code } = this.formConfig;

        v.props = {
          ...v.props,
          actCode: row.actCode,
          code,
          poolAccountCode: row.poolAccountCode || '',
          poolAccountType: row.poolAccountType || '',
        };
      }
      return v;
    },

    formComplete() {},
  },
};
